import serverApi from '../../utils/serverApi';

const waitlistService = {
  getList: (data) => serverApi({uri: 'join-waitlist', method: 'GET', data}),
};

export default waitlistService;
